// src/features/inventory/services/stock.js
import { apiClient } from '../../../services/api/client';

export const stockAPI = {
  getTransactions: (itemId, { lotId = null, limit = 100, offset = 0 } = {}) => {
    const params = new URLSearchParams({ limit, offset });
    if (itemId) params.set('item_id', itemId);
    if (lotId) params.set('lot_id', lotId);
    return apiClient.get(`/api/v1/inventory/stock/transactions?${params}`);
  },

  getStockLevelByLocation: (itemId) =>
    apiClient.get(`/api/v1/inventory/stock/items/${itemId}/level/by-location`),

  // unit_cost (DKK incl. moms) needs inventory:cost:update; left out, the item's cost price is used
  recordTransaction: ({ item_id, lot_id, quantity_change, reason, notes, location_id, unit_cost = null, update_cost_price = true }) =>
    apiClient.post('/api/v1/inventory/stock/transactions', {
      item_id,
      lot_id,
      quantity_change,
      reason,
      notes: notes || null,
      location_id: location_id || null,
      unit_cost,
      update_cost_price,
    }),

  // Undo: books the opposite transaction; the original is kept
  reverseTransaction: (stockTransactionId) =>
    apiClient.post(`/api/v1/inventory/stock/transactions/${stockTransactionId}/reverse`),

  transferStock: ({ item_id, from_location_id, to_location_id, quantity, lot_id, notes }) =>
    apiClient.post('/api/v1/inventory/stock/transfers', {
      item_id,
      from_location_id,
      to_location_id,
      quantity,
      lot_id: lot_id || null,
      notes: notes || null,
    }),
};
